const user = (state = [], action) => {
switch (action.type) {
case 'aaaa':
return{
...state,
email: action.user.email,
admin: action.user.admin
}
default:
return state
}
}

export default user


// WEBPACK FOOTER //
// ./src/reducers/user.js